import * as isEmail from 'validator/lib/isEmail';

import { ErrorMessage } from '../../GraphQL';

export const required = (value: string) => (value ? undefined : ErrorMessage.required);
export const email = (value: string) =>
  value && !isEmail(value) ? ErrorMessage.invalidEmailAddress : undefined;
export const phone = (value: string) => value ? undefined : ErrorMessage.invalidPhoneNumber;
export const asNumber = (value: string) =>
  value && !/^AS[1-9][0-9]*$/i.test(value) ? ErrorMessage.invalidAsNumber : undefined;



// WEBPACK FOOTER //
// /www/client/src/containers/Validator/validator.ts